module.exports = __webpack_public_path__ + "img/bule1.33c8594a.png";